import { SxProps, Theme } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const zeroResultsSx: {
	list: SxProps<Theme>;
	listItem: SxProps<Theme>;
	typografyP: SxProps<Theme>;
	typografyFS: SxProps<Theme>;
	suggestionButtons: SxProps<Theme>;
	suggestionContainer: SxProps<Theme>;
	root: SxProps<Theme>;
} = {
	root: { maxWidth: { xs: '320px', sm: '100%' } },
	list: {
		listStyleType: 'disc',
		pl: 4,
		borderTop: '1px solid',
		borderBottom: '1px solid',
		borderColor: 'grey.100',
		mt: '10px',
	},
	listItem: {
		display: 'list-item',
	},
	typografyP: { mt: '5px', mb: '10px' },
	typografyFS: { fontSize: '12px', minWidth: '121px' },
	suggestionButtons: {
		minWidth: 'fit-content',
		height: '42px',
		p: '5px 15px',
		fontSize: '16px',
		fontWeight: OpenSansFontWeights.bold,
		color: 'secondary.main',
		border: '2px solid',
		borderColor: 'secondary.main',
		backgroundColor: 'transparent',
		':hover': {
			border: '2px solid',
			color: 'white',
			borderColor: 'secondary.main',
			backgroundColor: 'secondary.main',
		},
	},
	suggestionContainer: {
		maxWidth: '100%',
		overflow: 'auto hidden',
		ml: '5px',
	},
};
